"use strict";
import Rails from '@rails/ujs';
import * as bootstrap from "bootstrap"
import * as styleInit from "js/style_inits"

window.addEventListener("turbolinks:load", () => {

	getOrSetResponseId();
	prepareSurveyQuestions();
	resetNextPages();
	getCustomParams();

	styleInit.initImgModal();
	styleInit.initStyleForm();


	// Refresh all questions when user makes major changes via Designer editor (like CSS or similar)
	let target = document.querySelector("#survey-questions")
	if (target) {
		let observer = new MutationObserver(function(mutations) {
	    mutations.forEach(function(mutation) {
	    	if (mutation.type == "childList") {
	    		console.log("Questions refreshed");
					prepareSurveyQuestions();
	    	}
	    });
		});

		observer.observe(target, {childList: true})		
	}

});

function prepareSurveyQuestions() {
	let surveyQuestions = document.querySelector("#survey-questions")
	let isSinglePage = false
  if (surveyQuestions) {
  	setOtherOptionField()

	  let questionsBlock = document.querySelector("#questions")
	  if (questionsBlock) {
	  	isSinglePage = questionsBlock.dataset.singlePage == "true"
	  }

		let firstPage = document.querySelector("#survey-questions .questions .form-page-card");

  	firstPage.classList.remove("hidden")
  	if (firstPage.querySelector(".form-control")) {
  		firstPage.querySelector(".form-control").focus();
  	}

		// For checkbox type question - check if question is required and set validation trigger
		document.querySelectorAll(".form-page-card").forEach((formPage) => {
			setNextQuestionForBranches(formPage);
			initPrevBtn(formPage);
			initRequiredCheckboxes(formPage);
		});
	 
	}
}

function setNextQuestionForBranches(formPage) {
	let pageCard = formPage.closest(".form-page-card");
	if (pageCard.dataset.branching == "true") {
		formPage.addEventListener("submit", (event) => {
			let nextPageIdInput = pageCard.querySelector(".page-hidden-fields .next-page-id")
			let nextPageId = pageCard.querySelector(".page-hidden-fields .next-page-id").value

			// If no Next Question ID is set on default, check selected options for next question
			if (nextPageIdInput) {
				let branchedQuestionSelection = formPage.querySelector(".question-response-card.question-branched")
				let selectedOptions = branchedQuestionSelection.querySelectorAll("input:checked");
				for ( let opt of selectedOptions) {
					if (opt && opt.checked && opt.dataset.nextQuestionId) {
						nextPageId = opt.dataset.nextQuestionId				
						break; // When multiple answers (checkboxes) are possible, the first checked answer determines the next question
					}
				}
			}

			// If next Question is set, make sure that it is displayed on submit
			if (nextPageId) {
				console.log("Moving to next page ID: " + nextPageId)
				nextPageIdInput.value = nextPageId;
				let nextPage = document.querySelector("#form-page-"+nextPageId);
				formPage.querySelector(".page-hidden-fields .next-page-ends").value = (nextPage.dataset.ending == "true");
			}

		})
	}
}

function initPrevBtn(formPage) {
	let prevBtn = formPage.querySelector(".btn-prev-question")
	if (prevBtn) {
		prevBtn.addEventListener("click", (event) => {
			let prevPageId = formPage.querySelector(".prev-page-id").value
			if (prevPageId) {
				// Re-set the default next-page-id in case the newly selected option does not have a defined next question
				let prevFormPage = document.querySelector("#form-page-"+prevPageId)
				let defNextPageId = prevFormPage.querySelector(".default-next-page-id").value
				prevFormPage.querySelector(".next-page-id").value = defNextPageId

				formPage.closest(".form-page-card").classList.add("hidden");
				prevFormPage.classList.remove("hidden");
			}
			event.preventDefault();
		})
	}
}

// Custom validation for at least one checkbox selected (other fields use HTML-native validation)
function initRequiredCheckboxes(formPage) {
	let requiredQuestions = formPage.querySelectorAll(".question-response-card.question-required")
	requiredQuestions.forEach((qrForm) => {
		let isMultipleCheckboxes = qrForm.querySelectorAll("input[type='checkbox']")[0]
		if (isMultipleCheckboxes) {
			qrForm.querySelector(".btn-submit").addEventListener("click", (event) => {
				let form = event.target.closest("form");
				let noneChecked = form.querySelectorAll("input[type='checkbox']:checked").length == 0
				let firstCheckbox = form.querySelectorAll("input[type='checkbox']")[0];
				if (noneChecked) {
					firstCheckbox.setCustomValidity("Please select at least one option.");
					firstCheckbox.reportValidity();
					Rails.stopEverything(event);
				} else {
					firstCheckbox.setCustomValidity("")
				}
			})	
		}
	})
}
 
function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function getCustomParams() {
	// Get and set custom fields from URL path
	let customParams = window.location.search.substr(1);
	if (customParams) {
		// Parse custom params into array of arrays with params
		let contactDetails = customParams.split("&").map(t => { let i = t.split("="); return [i[0],i[1]];})
		console.log(contactDetails) 

		// Find choice option ID if set & remove it from other details
	 	for( var i = 0; i < contactDetails.length; i++){                              
      if ( contactDetails[i][0] === "choice") { 
    		setChoiceAnswer(contactDetails[i][1])
        contactDetails.splice(i, 1); 
        i--; 
      }
    }

    // Enter custom params into hidden inputs to save with Response
		let contactDetailsInput = document.querySelectorAll(".contact-details")[0]
		if (contactDetailsInput) {
			contactDetailsInput.value = JSON.stringify(contactDetails);
		}

		// Set Pipes based on custom params
		contactDetails.forEach((data) => {
			let pipesForParam = document.querySelectorAll(".card-body h3.title, .card-body p.description, .card-body label.form-check-label").forEach((textLabel) => { 
				textLabel.innerHTML = textLabel.innerHTML.replace("{{"+ data[0] +"}}", data[1])
			})
		})
	}

}

function setChoiceAnswer(optionId) {
	let choiceOption = document.getElementById(optionId);
	if (choiceOption) {
		choiceOption.checked = true
	}
}

function getOrSetResponseId() {
	// Get or set responses object from or to localStorage
	let formId = window.location.pathname.split("/")[1];
	let responses = JSON.parse(localStorage.getItem("responses"));
	let formResponseId = null

	if (responses) {
		// When "responses" object exists, check for formId existence
		let formResponse = responses[formId]
		if (formResponse) {
			formResponseId = formResponse["responseId"]

			// Display "Survey responded" text when already finished
			if (formResponse["survey-finished"] == "true")  {
				let surveyFinishedDOM = document.querySelector("#survey-finished");
				if (surveyFinishedDOM) {
					surveyFinishedDOM.classList.remove("d-none");
					let questionsList = document.querySelector("#survey-questions");
					if (questionsList) {
						questionsList.remove();
					}
				}
			}
		} else {
			// When object for selected formId does not exist, prepare one
			responses[formId] = {}
		}
	} else {
		// When "responses" object does not exist, prepare one
		responses = {}
		responses[formId] = {}
	}
	console.log(formResponseId);

	if (!formResponseId)  {
		formResponseId = uuidv4();
		responses[formId] = {"responseId": formResponseId}
		localStorage.setItem("responses", JSON.stringify(responses));
	}
	
	// Set response ID on all response form_tags hidden fields
	var responseIdFields = document.querySelectorAll(".form-response-id");
	responseIdFields.forEach((field) => {
		field.value = formResponseId;
	})
}

function setOtherOptionField() {
	// Enable "other" input when "Other" option is selected
  let optionForOtherChoice = document.querySelectorAll("input#option-Other");
  if (optionForOtherChoice.length > 0) {
  	optionForOtherChoice.forEach((checkBox) => {
  		let otherInput = checkBox.closest("li").querySelector(".text-other");
  		checkBox.addEventListener("change", (event) => {
	  		if (checkBox.checked == true) {
					otherInput.disabled = false
					otherInput.focus()
	  		} 
	  	})
		})
  }
}

function resetNextPages() {
	document.querySelectorAll(".form-page-card").forEach((formPage) => {
		// Re-set the default next-page-id in case the newly selected option does not have a defined next question
		if (formPage.querySelector(".next-page-id")) {
			let defaultNextPageId = formPage.querySelector(".default-next-page-id").value
			formPage.querySelector(".next-page-id").value = defaultNextPageId
		}
	})
	
}




